import { timeFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const TimeCell: FC<ITableCellProps> = ({ value }) => {
    return (
        <div className="TimeCell">
            <span className="value">{timeFilter()(value, null)}</span>
        </div>
    );
};
TimeCell.displayName = "TimeCell";
